import { render, staticRenderFns } from "./AdditionalPurchase.vue?vue&type=template&id=72e377e5&scoped=true&"
import script from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
export * from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPurchase.vue?vue&type=style&index=0&id=72e377e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e377e5",
  null
  
)

export default component.exports